import React from 'react';
import styled from 'styled-components';
import Navbar from './Navbar';
import Island from './Island';
import { breakpoints } from '../../constants/styles';
import { ThemeProvider } from 'styled-components';
import theme from '../theme/theme';
import { padding } from 'styled-system';

const BaseStyle = styled.div`
  position: relative;
  overflow: hidden;
`;

const StyledContent = styled.div`
  justify-content: center;
  ${padding}
  margin-top: 50px;
`;

export default function FinautaPageBase({ children }) {
  return (
    <BaseStyle>
      <Navbar />
      <ThemeProvider theme={theme}>
        <StyledContent padding={['20px', '80px', '200px']}>{children}</StyledContent>
      </ThemeProvider>
    </BaseStyle>
  );
}
